module.exports = __webpack_public_path__ + "img/buy-n-large.16940aae.svg";